export const INDEED_FLEX_SHIFT_ISSUE_LABELS = {
  position_not_mapped: 'Position not mapped',
  location_not_mapped: 'Location not mapped',
  missing_company: 'Missing company',
  failed_to_create: 'Shift not created',
  failed_to_cancel: 'Failed to cancel',
  worker_missing_attestation: 'Worker missing attestation',
  worker_counts_inconsistency: 'Worker counts inconsistency',
  work_missing_in_workwhile: 'Work missing in WorkWhile',
  work_missing_in_indeed_flex: 'Work missing in Indeed Flex',
  clocks_inconsistency: 'Clocks inconsistency',
  break_inconsistency: 'Break inconsistency',
  not_processed: 'Not processed',
} as const

export type IndeedFlexShiftIssue = keyof typeof INDEED_FLEX_SHIFT_ISSUE_LABELS

export const INDEED_FLEX_SHIFT_ISSUE_VALUES = Object.keys(
  INDEED_FLEX_SHIFT_ISSUE_LABELS
) as IndeedFlexShiftIssue[]

export const INDEED_FLEX_SHIFT_ISSUE_OPTIONS = (
  Object.entries(INDEED_FLEX_SHIFT_ISSUE_LABELS) as [
    IndeedFlexShiftIssue,
    (typeof INDEED_FLEX_SHIFT_ISSUE_LABELS)[IndeedFlexShiftIssue],
  ][]
).map(([value, label]) => ({ value, label }))

const INDEED_FLEX_TIMESHEET_ONLY_ISSUES = new Set<IndeedFlexShiftIssue>([
  'clocks_inconsistency',
  'break_inconsistency',
])

export function isIndeedFlexTimesheetOnlyIssues(
  issues: IndeedFlexShiftIssue[]
): boolean {
  return (
    issues.length > 0 &&
    issues.every((issue) => INDEED_FLEX_TIMESHEET_ONLY_ISSUES.has(issue))
  )
}
